<template>
  <resource-filter></resource-filter>
</template>

<script>
import store from "../../store/store";
import ResourceFilter from "./ResourceFilter";
import {Mixin} from "/src/mixins/index.js";

export default {
  name: "ResourceReport",
  mixins: [Mixin],
  components: {
    ResourceFilter
  },
  data() {
    return {};
  },

  methods: {},
  mounted() {
    store.commit("showLoader", false); // Loader Off
  },
};
</script>

